<script lang="ts" setup>
    const props = defineProps<{
        formObj?: any,
        formId: string,
        gravityFormId: number,
        reversedBtnHover?: boolean,
        class?: string
    }>();

    let formData: any = null;

    if (props?.formObj === undefined) {
      formData = await useForm(`${props?.gravityFormId}`);
    } else {
      formData = props?.formObj;
    }

    const formClass = props?.class ?? '';

    const buttonText = props?.formObj?.button?.text ? props?.formObj?.button?.text : 'Submit Enquiry';
    const config = useRuntimeConfig();
    const reversedBtnHover = props?.reversedBtnHover === undefined ? false : props?.reversedBtnHover;
</script>
<template>
    <form :id="props?.formId" :class="`gravity-form signup-form d-flex flex-wrap ${formClass}`"
        :action="`${config?.public?.base_url}/wp-json/gf/v2/forms/${props.gravityFormId}/submissions`">

        <div class="d-none mb-3 col-12" id="submit-message"></div>
        <template v-for="field in formData?.fields">
            <div v-if="field?.inputType === 'name'" class="form-group col-md-6 col-12 pe-3 pb-3">
                <label :for="`fld-${formId}-${field.id}`">{{ field?.label }}<span v-if="field?.isRequired" class="required">*</span></label>
                <input v-if="field?.isRequired" type="text" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" required />
                <input v-else type="text" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" />
            </div>
            <div v-else-if="field?.inputType === 'email'" class="form-group col-md-6 col-12 pe-3 pb-3">
                <label :for="`fld-${formId}-${field.id}`">{{ field?.label }}<span v-if="field?.isRequired" class="required">*</span></label>
                <input v-if="field?.isRequired" type="email" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" required />
                <input v-else type="email" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" />
            </div>

            <div v-else-if="field?.inputType === 'phone'" class="form-group col-md-6 col-12 pe-3 pb-3">
                <label :for="`fld-${formId}-${field.id}`">{{ field?.label }}<span v-if="field?.isRequired" class="required">*</span></label>
                <input v-if="field?.isRequired" type="tel" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" required/>
                <input v-else type="tel" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`"/>
            </div>
            <div v-else-if="field?.inputType === 'textarea'" class="col-md-12 pe-3 pb-3 w-100">
              <label :for="`fld-${formId}-${field.id}`" class="form-label text-capitalize">{{field.label}} <span v-if="field?.isRequired" class="required">*</span></label>
              <textarea v-if="field?.isRequired" :name="`input_${field.id}`" rows="8" :class="`form-control`" :id="`fld-${formId}-${field.id}`" required></textarea>
              <textarea v-else :name="`input_${field.id}`" rows="8" :class="`form-control`" :id="`fld-${formId}-${field.id}`"></textarea>
            </div>
            <div v-else-if="field?.inputType === 'radio'" :class="`${field?.layoutGridColumnSpan ? 'form-group col-md-'+field?.layoutGridColumnSpan : 'col-md-12'} col-12 pe-3 pb-3 checkbox-container`">
              <label v-if="field?.labelPlacement !== 'hidden_label'">{{ field?.label }}</label>
              <div class="choices-div pt-2 d-flex">
                <template v-for="(choice, index) in field?.choices">
                  <input type="radio" :id="`fld-${formId}-${field.id}-cb-${index}`" :name="`input_${field.id}`" :value="choice?.value">
                  <label :for="`fld-${formId}-${field.id}-cb-${index}`" class="me-3">{{ choice?.text }}</label>
                </template>
              </div>
            </div>
            <div v-else-if="field.inputType === 'captcha'" class="col-md-12 pb-3">
              <div class="g-recaptcha" :data-sitekey="config.public.captcha_site_key"></div>
            </div>
            <div v-else class="form-group col-md-6 col-12 pe-3 pb-3">
                <label :for="`fld-${formId}-${field.id}`">{{ field?.label }}<span v-if="field?.isRequired" class="required">*</span></label>
                <input v-if="field?.isRequired" type="text" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`" required/>
                <input v-else type="text" :id="`fld-${formId}-${field.id}`" :name="`input_${field.id}`"/>
            </div>
        </template>
        <div class="form-actions d-flex col-md-12 mt-4">
            <button type="submit" :class="`btn btn-primary rounded-pill text-uppercase ${reversedBtnHover ? 'reversed-hover' : ''}`">
                {{ buttonText }}
            </button>
        </div>
    </form>
</template>